import { Injectable, signal, WritableSignal } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class DimensionsSyncService {
  private _width: WritableSignal<number | null> = signal<number | null>(null);
  private _styleWidth: WritableSignal<string> = signal<string>("100%");
  width = this._width.asReadonly();
  styleWidth = this._styleWidth.asReadonly();

  setWidth(width: number) {
    this._width.set(width);
    if (!width) {
      this._styleWidth.set("100%");
    } else {
      this._styleWidth.set(width + "px");
    }
  }
}
